import { GenerateFields } from '@components/common/Forms/GenerateFields/GenerateFields';
import { CommonFilterForm } from '@type/filters';
import { careerLevels } from '@components/features/filters/helpers/filterObjects';


/**
 * @description Generates the fields for the career levels filter group.
 * * **recordFunc** - the 'record' function from useBjForm.
 * * **verticalSpacing** - the spacing between the items. Defaults to 'my-1.5'.
 * * **idPrefix** - the prefix for the form elements ids. When using multiple forms on the same page,
 * this is needed to avoid duplicate ids.
 */
export const CareerLevelsForm = (props: CommonFilterForm) => {
  // Destructure props
  const {
    recordFunc,
    verticalSpacing = 'my-1.5 gap-0.5',
    idPrefix,
  } = props;

  // Render component
  return (
    <GenerateFields
      recordFunc={recordFunc}
      filterObject={careerLevels}
      spacing={verticalSpacing}
      idPrefix={idPrefix}
    />
  );
};
